let lastEditedInput = '';

$('body').on('keyup', '.lingronTestInput', function() {
  let length = $(this).data('length')-2;
  let curLength = $(this).val().length;
  let index = $('.lingronTestInput').index(this);
  lastEditedInput = $(this);

  if( length === curLength ) {
    $('.lingronTestInput').eq(index + 1).focus();
    lastEditedInput = $('.lingronTestInput').eq(index + 1);
  }
});

$('body').on('click', '.lingronTestInputWrong', function() {
  // $('.lingronTestInputWrong').val('');
  $(this).val('');
  $('.lingronTestInputWrong').data('missed', false);
  // let missed = $(this).data('missed');
  // console.log('rossz valasz klikked2', $(this));
});

$('body').on('click', '.lingronSpecialCharacterButton', function() {
  //Get the special character
  let value = $(this).data('value');

  //Get the last edited input & add a special character
  let inputValue = lastEditedInput.val();
  lastEditedInput.val(inputValue + value);

  //Focus again this input
  lastEditedInput.focus();

  //Check input value length
  let length = lastEditedInput.data('length')-2;
  let curLength = lastEditedInput.val().length;
  let index = $('.lingronTestInput').index(lastEditedInput);

  if( length === curLength ) {
    $('.lingronTestInput').eq(index + 1).focus();
    lastEditedInput = $('.lingronTestInput').eq(index + 1);
  }
});